var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.days),function(day){return _c('location-schedule-item',{key:day.key,attrs:{"keyName":day.key,"label":day.label,"value":day.value,"limit":_vm.limit,"add-text":_vm.addText},on:{"change":_vm.updateData}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }